import React from "react";
import { Link } from "react-router-dom";
import makeHand from "../../Assets/make-hand.webp";
import makeLeg from "../../Assets/make-leg.webp";
import makeOther from "../../Assets/make-other.webp";
import "./YogaVariations.css";

// `to` is the page the button under the chart opens
const CHARTS = [
  {
    src: makeHand,
    alt: "10 hand variations",
    to: "/how-to-make-variation/hand-variations",
    cta: "Explore Hand Variations",
  },
  {
    src: makeLeg,
    alt: "17 yoga leg variation poses",
    to: "/how-to-make-variation/leg-variations",
    cta: "Explore Leg Variations",
  },
  {
    src: makeOther,
    alt: "7 variations of other yoga",
    to: "/how-to-make-variation/other-variations",
    cta: "Explore Other Variations",
  },
];

const HowToMakeVariations = () => (
  <section
    className="yoga-variations yoga-make"
    aria-labelledby="yoga-make-title"
  >
    <h2 id="yoga-make-title">How to Make Variations</h2>

    <div className="yoga-variations-grid yoga-flows-grid">
      {CHARTS.map((c) => (
        <figure className="yoga-variation-card yoga-flow-card" key={c.alt}>
          <div className="yoga-flow-frame">
            <img src={c.src} alt={c.alt} loading="lazy" />
          </div>
          <Link className="yoga-variation-link" to={c.to}>
            {c.cta}
          </Link>
        </figure>
      ))}
    </div>
  </section>
);

export default HowToMakeVariations;
